import { useMediaQuery } from "@mui/material";
import { tutorialAssets } from "assets/cdn";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import usePopUpsV2 from "components/PopUpManagerV2/hooks/usePopUpsV2";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { IShopLoyaltyOffer } from "contexts/WebStoreProvider/types";
import { useLinks } from "hooks";
import { useImagePath } from "hooks/useImagePath";
import { useCallback, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { offersApi } from "redux/apis";
import {
	Body,
	Button,
	ButtonsContainer,
	Container,
	Header,
	SubTitle,
	Title
} from "./styles";

export const FirstPurchase = () => {
	const { getImage } = useImagePath("cdn");
	const links = useLinks();
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const { close, stack } = usePopUpsV2();
	const { userTracker } = useWebStoreContext();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const isPortrait = useMediaQuery("(orientation: portrait)");
	const backgroundImage = getImage(tutorialAssets.firstPurchaseBg);
	const scale = useCalculateScale(
		isPortrait ? 363 + 40 : 956 + 40,
		isPortrait ? 613 + 40 : 410 + 40
	);
	const payloadLp = stack.find(({ id }) => id === "first-purchase")?.payload
		?.lp;

	const lp =
		typeof payloadLp === "number" ? payloadLp.toLocaleString("en-US") : 0;
	const { data: loyaltyOffers } = offersApi.endpoints.getOffers.useQueryState({
		offerType: "loyalty",
		isAuthenticated: true
	});
	const hasEnoughLP = useMemo(() => {
		return loyaltyOffers?.offers?.some(
			(offer: IShopLoyaltyOffer) =>
				offer.loyaltyPointPrice <= Number(userTracker?.loyaltyPoints)
		);
	}, [loyaltyOffers, userTracker?.loyaltyPoints]);

	const reportAnalytics = useCallback(
		(event_name: string, action: string) => {
			reportPlaygamiEvent("tp.web_frontend", {
				event_name,
				event_type: "first_purchase_success_dialog",
				action,
				source: "purchase_success_dialog"
			});
		},
		[reportPlaygamiEvent]
	);

	const onXClose = () => {
		reportAnalytics("dialog_x_closed", "dialog_x_closed");
		close({ id: "first-purchase" });
		if (
			userTracker?.metadata?.hasSeenTutorial !== "true" &&
			pathname !== links.shop.path
		) {
			navigate(links.shop.path);
		}
	};

	const handleViewLoyaltyShop = () => {
		reportAnalytics("dialog_click", "view_loyalty_shop_click");
		close({ id: "first-purchase" });
		navigate(links.loyalty.path);
	};

	useEffect(() => {
		reportAnalytics("dialog_shown", "dialog_shown");

		const body = document.body;
		const html = document.documentElement;
		const previousBodyOverflow = body.style.overflow;
		const previousHtmlOverflow = html.style.overflow;

		body.style.overflow = "hidden";
		html.style.overflow = "hidden";

		return () => {
			body.style.overflow = previousBodyOverflow;
			html.style.overflow = previousHtmlOverflow;
		};
	}, []);

	return (
		<Container scale={scale}>
			<CloseIconButton onClose={onXClose} />
			<Header style={{ backgroundImage: `url(${backgroundImage})` }} />
			<Body>
				<Title>
					<div>
						Your purchase is in your
						<br /> in-game inbox!
					</div>
				</Title>

				<SubTitle>
					You also earned <strong>{lp} Loyalty Points</strong>.
					<br />{" "}
					{hasEnoughLP ? (
						<>
							Spend them on free rewards in the
							<br /> Loyalty Shop.
						</>
					) : (
						<>
							You can use them to unlock free
							<br /> rewards in the Loyalty Shop.
						</>
					)}
				</SubTitle>
				<ButtonsContainer>
					<Button
						variant="contained"
						themeColor="primary"
						onClick={handleViewLoyaltyShop}
					>
						View Loyalty Shop
					</Button>
				</ButtonsContainer>
			</Body>
		</Container>
	);
};
